module.exports = __webpack_public_path__ + "img/logo.adf1ff0b.svg";